import { useEffect } from 'react';

interface ModalProps {
  head: string;
  message: string;
  messageSub?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function ConfirmModal({ head, message, messageSub, isOpen, onClose, onConfirm }: ModalProps) {
  useEffect(() => {
    if (!isOpen) return;

    // 모달이 열릴 때 히스토리에 더미 상태 추가
    window.history.pushState({ modalOpen: true }, '');

    const handlePopState = () => {
      // 뒤로 가기 이벤트 발생 시 모달 닫기
      onClose();

      // 뒤로가기로 닫히면 상태 복구 (뒤로가기 방지)
      window.history.pushState({ modalOpen: false }, '');
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      // 모달이 닫힐 때 이벤트 제거
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null; // 모달이 열려있지 않으면 아무것도 렌더링하지 않음

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
      <div className="w-[320px] rounded-lg bg-bg_modal_popup pb-[16px] pt-[32px] text-[16px] shadow-lg">
        <h2 className="mb-[10px] text-center text-base font-medium leading-5 text-white">{head}</h2>
        <p className="text-center text-base text-[10px] font-normal leading-4 text-text_secondary">{message}</p>
        {messageSub && messageSub !== '' && <p className="mt-[24px] text-[14px] text-[#646464]">{messageSub}</p>}
        <div className="mt-[24px] flex justify-between space-x-2 px-[16px]">
          <button
            onClick={onClose}
            className="w-full rounded-[6px] bg-btText py-3 font-medium text-inputText text-white"
          >
            아니오
          </button>
          <button onClick={onConfirm} className="w-full rounded-[6px] bg-white py-3 font-medium text-btText transition">
            네
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
